import React, { Component } from 'react';
import { connector, store } from '../store';
import { css } from '@emotion/core';

import Core from '../../Core/Core';

const contentItemPassportIndicator = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 75px;
  height: 75px;
  z-index: 1;
`;

export class PassportLabel extends Component {
  render() {
    if (!this.props.video.isPassport && !this.props.video.isExpiring) {
      return <div></div>;
    }

    let passportLabel, imgUrl = Core.ASSETS_URL + 'passport-rose';

    if (this.props.video.isWatchable) {
      passportLabel = this.props.video.isExpiring ? 'Expiring soon' : 'TPT Passport';
    } else {
      passportLabel = this.props.userSignedIn ? 'Activate to watch' : 'Sign in to watch';
    }

    if (this.props.isVideo) {
      imgUrl += '-inverse.svg';
    } else {
      imgUrl += '.svg';
    }

    return <div className="content-item-passport-indicator">
      {/* <img src={imgUrl} className="passport-icon" alt="Passport icon" /> */}
      {this.props.isVideo &&
        <span className="passport-label">{passportLabel}</span>
      }
      <svg css={contentItemPassportIndicator} width="142" height="142" viewBox="0 0 142 142" fill="none" xmlns="http://www.w3.org/2000/svg" class="pbs-passport-compass-rose--corner" aria-label="Passport"><path d="M0 0v141.23L141.23 0H0z" fill="#5680FF" /><path fill-rule="evenodd" clip-rule="evenodd" d="M10.088 40.025c0-16.508 13.5-29.937 30.095-29.937 16.593 0 30.094 13.43 30.094 29.937S56.777 69.96 40.183 69.96c-16.595 0-30.095-13.43-30.095-29.936zm24.233-5.831l5.745-19.45c-13.923.063-25.235 11.316-25.298 25.165l19.553-5.715zm-19.553 5.945l19.553 5.716 5.745 19.449c-13.923-.062-25.235-11.316-25.298-25.165zm25.53 25.165l5.745-19.45 19.551-5.715c-.062 13.849-11.374 25.103-25.297 25.165zm25.297-25.395c-.062-13.85-11.374-25.103-25.297-25.165l5.745 19.45 19.552 5.715z" fill="#fff" /><path fill-rule="evenodd" clip-rule="evenodd" d="M32.521 28.731l-.838 2.839-2.853.834-4.437-8.086 8.128 4.413zM55.97 24.32l-4.436 8.086-2.854-.834-.838-2.84 8.128-4.412zm-8.127 27l.839-2.84 2.854-.833 4.435 8.085-8.128-4.413zM28.83 47.645l-4.436 8.085 8.128-4.413-.838-2.838-2.854-.834z" fill="#fff" /></svg>
    </div>;
  }
}

export default connector(PassportLabel);
